import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  user: {
    user_id: null,
    work_email: null,
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.token = action.payload.token;
      state.user = {
        user_id: action.payload.user_id,
        work_email: action.payload.work_email,
      };
    },
    clearUserData: (state) => {
      state.token = null;
      state.user = { user_id: null, work_email: null };
    },
  },
});

export const { setUserData, clearUserData } = userSlice.actions;
export default userSlice.reducer;
